import {Mailbox} from './mailbox.model';

export function mapMailboxToStore(mailbox: Mailbox) {
	const inbound = mailbox.inbound_configuration;
	const outbound = mailbox.outbound_configuration;

	return {
		inbound: {
			client: inbound?.client ?? '',
			email: inbound?.username ?? '',
			username: inbound?.username ?? '',
			imap_host: inbound?.imap_host ?? '',
			folder: inbound?.folder ?? 'INBOX',
			imap_port: inbound?.imap_host ?? '',
			protocol: inbound?.protocol ?? '',
			idle_enabled: inbound?.idle_enabled ?? false,
			ssl_enabled: inbound?.ssl_enabled ?? false,
			start_tls_enabled: inbound?.start_tls_enabled ?? false,
		},
		outbound: {
			client: outbound?.client ?? '',
			email: outbound?.email_user_name ?? '',
			username: outbound?.email_user_name ?? '',
			email_host: outbound?.email_host ?? '',
			alias: outbound?.email_configuration_alias ?? '',
			fromName: outbound?.email_from_name ?? '',
			email_configuration_alias: outbound?.email_configuration_alias ?? '',
			from_name: outbound?.email_from_name ?? '',
			from_address: outbound?.email_from_address ?? '',
			smtp_port: outbound?.smtp_port ?? '',
			starttls_enable: outbound?.starttls_enable ?? '',
			mail_debug: outbound?.mail_debug ?? '',
			transport_protocol: outbound?.transport_protocol ?? '',
			email_auth: outbound?.email_auth ?? '',
			email_mime_charset: outbound?.email_mime_charset ?? '',
		}
	};
}
